import {
  type AcpKnownAgentFamily,
  acpAgentCatalogEntry,
  canonicalAcpAgentId,
  knownAcpAgentFamily,
} from '@crowdex/agent-contracts';

export type CrowdexKnownAgentFamily = AcpKnownAgentFamily;

/** Resolves stable agent families used for Crowpus injection and pre-session UX. */
export function crowdexKnownAgentFamilyForAgentId(agentId: string): CrowdexKnownAgentFamily | null {
  return knownAcpAgentFamily(agentId);
}

/** Canonical registry id accepted by the cloud control plane. */
export function canonicalCrowdexAcpAgentId(agentId: string): string {
  return canonicalAcpAgentId(agentId);
}

export type CrowdexAgentIdentity = {
  /** Known UX family; execution still uses the same generic ACP session path. */
  family: CrowdexKnownAgentFamily | null;
};

/** Resolves optional family metadata contributed by the owning ACP agent plugin. */
export function resolveCrowdexAgentIdentity(input: {
  id: string;
  command?: string | null;
}): CrowdexAgentIdentity | null {
  const entry = acpAgentCatalogEntry(input);
  return entry === null ? null : { family: entry.family };
}
